<ion-buttons class="custom-close-button" (click)="dismiss()">
  <span class="icon-CLOSE"></span>
</ion-buttons>
<ion-header class="header-md header-collapse-none">
  <ion-toolbar class="toolbar-title-default in-toolbar">
    <ion-title class="modal-title px-0" slot="">
      <div class="modal-title">
        {{ 'cookies-modal.title' | translate }}
      </div>
    </ion-title>
  </ion-toolbar>
  <ion-item-divider class=""></ion-item-divider>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid>
    <ion-row>
      <ion-col text-center class="p-0">
        <div class="policity-content">
          <p [innerHTML]="'cookies-modal.section-1' | translate"></p>
          <p>
            {{ 'cookies-modal.section-1-text-1' | translate }}
            <a (click)="openCookiesPage()" class="externo">{{
              'cookies-modal.link' | translate
            }}</a
            >.
            {{ 'cookies-modal.section-1-text-2' | translate }}
          </p>
        </div>

        <div
          class="policity-content"
          [innerHTML]="'cookies-modal.section-2' | translate"
        ></div>
        <div
          class="policity-content"
          [innerHTML]="'cookies-modal.section-3' | translate"
        ></div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
